import { Box, Tab, Tabs } from "@mui/material";
import { Fragment, ReactNode, SyntheticEvent, useEffect, useRef, useState } from "react";

import HeaderedFullHeightContainer from "@/components/headered-full-height-container";

export interface AppTabItem {
  value: any;
  label?: ReactNode;
  render: () => ReactNode;
  condition?: () => boolean;
  keepMounted?: boolean;
}

const TabContent = ({
  keepMounted,
  isSelected,
  children,
}: {
  keepMounted?: boolean;
  isSelected: boolean;
  children: ReactNode;
}) => {
  if (keepMounted !== undefined) {
    return (
      <Box
        sx={{
          display: isSelected ? "static" : keepMounted ? "none" : "static",
        }}
      >
        {children}
      </Box>
    );
  }

  return isSelected ? children : null;
};

const AppFullPageTabs = ({
  defaultValue,
  items = [],
  onTabChange,
}: {
  defaultValue?: any;
  items?: AppTabItem[];
  onTabChange?: (val: any) => void;
}) => {
  const [tabValue, setTabValue] = useState<any>(defaultValue);

  // Добавляем эффект для синхронизации tabValue с defaultValue при изменениях. Нужен для Линка на сессю в аккаунтах
  useEffect(() => {
    setTabValue(defaultValue);
  }, [defaultValue]);

  const handleChangeTab = (_event: SyntheticEvent<Element, Event>, value: any) => {
    onTabChange?.(value);
    setTabValue(value);
  };

  return (
    <HeaderedFullHeightContainer
      header={
        <Tabs
          onChange={handleChangeTab}
          value={tabValue}
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {items
            .filter((item) => !item.condition || item.condition())
            .map((item) => (
              <Tab key={item.value} label={item.label} value={item.value} />
            ))}
        </Tabs>
      }
    >
      <>
        {items
          .filter((item) => !item.condition || item.condition())
          .map((item) => {
            const isSelected = item.value === tabValue;
            return (
              <TabContent
                key={item.value}
                isSelected={isSelected}
                keepMounted={item.keepMounted}
              >
                {item.render()}
              </TabContent>
            );
          })}
      </>
    </HeaderedFullHeightContainer>
  );
};

export default AppFullPageTabs;
